var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webContent flex" }, [
    _c(
      "div",
      {
        staticClass: "mine",
        class: {
          ts_mine: _vm.$h5Power == "instructor" || _vm.$h5Power == "teacher"
        }
      },
      [
        _c("div", { staticClass: "area" }, [
          _c("div", { staticClass: "user df hao" }, [
            _c("div", { staticClass: "user-left" }, [
              _c("div", { staticClass: "uname" }, [_vm._v(_vm._s(_vm.user))]),
              _vm._v(" "),
              _c("div", { staticClass: "point" }, [
                _c("img", {
                  staticStyle: { width: ".11rem", height: ".15rem" },
                  attrs: { src: require("../../../assets/point2.png") }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "point-tip" }, [_vm._v("积分")]),
                _vm._v(" "),
                _c("span", [_vm._v("|")]),
                _vm._v(" "),
                _c("span", { staticClass: "point-tip" }, [
                  _vm._v(_vm._s(_vm.point))
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "jifenbang", on: { click: _vm.toJifenbang } },
              [
                _c("img", {
                  staticStyle: {
                    width: ".15rem",
                    height: ".16rem",
                    "margin-right": ".04rem"
                  },
                  attrs: { src: require("../../../assets/h5-jifen.png") }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("积分榜")])
              ]
            )
          ]),
          _vm._v(" "),
          _vm.$h5Power == "instructor" || _vm.$h5Power == "teacher"
            ? _c("div", { staticClass: "social2" }, [
                _c("div", { staticClass: "uduty" }, [_vm._v(_vm._s(_vm.duty))]),
                _vm._v(" "),
                _c("div", { staticClass: "socialLine df hao" }, [
                  _c("div", { staticClass: "socialLi" }, [
                    _c("em", [_vm._v(_vm._s(_vm.followCount2))]),
                    _vm._v("关注我的人")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "socialLi" }, [
                    _c("em", [_vm._v(_vm._s(_vm.followCount))]),
                    _vm._v("我关注的人")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "socialLine2 df hao" }, [
                  _c("div", { staticClass: "socialLi socialLi2" }, [
                    _vm._v("得到"),
                    _c("em", [_vm._v(_vm._s(_vm.likeCount))]),
                    _vm._v("点赞")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "socialLi socialLi3" }, [
                    _vm._v("已被"),
                    _c("em", [_vm._v(_vm._s(_vm.collectCount))]),
                    _vm._v("次收藏")
                  ])
                ])
              ])
            : _c("div", { staticClass: "social df hao" }, [
                _c("div", { staticClass: "socialLi" }, [
                  _c("em", [_vm._v(_vm._s(_vm.followCount))]),
                  _vm._v("关注的人")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "socialLi socialLi2" }, [
                  _vm._v("得到"),
                  _c("em", [_vm._v(_vm._s(_vm.likeCount))]),
                  _vm._v("点赞")
                ])
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "model df hao" }, [
            _c(
              "div",
              {
                staticClass: "modelLi flex df cf wao hao",
                class: { cur: _vm.chooseModel == "ask" },
                on: {
                  click: function($event) {
                    return _vm.tabModel("ask")
                  }
                }
              },
              [_c("b", [_vm._v(_vm._s(_vm.model.ask))]), _vm._v("问题")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modelLi flex df cf wao hao",
                class: { cur: _vm.chooseModel == "follow" },
                on: {
                  click: function($event) {
                    return _vm.tabModel("follow")
                  }
                }
              },
              [
                _c("b", [_vm._v(_vm._s(_vm.model.follow))]),
                _vm._v(
                  _vm._s(
                    _vm.$h5Power == "instructor" || _vm.$h5Power == "teacher"
                      ? "关注"
                      : "我关注的"
                  )
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modelLi flex df cf wao hao",
                class: { cur: _vm.chooseModel == "collect" },
                on: {
                  click: function($event) {
                    return _vm.tabModel("collect")
                  }
                }
              },
              [_c("b", [_vm._v(_vm._s(_vm.model.collect))]), _vm._v("收藏夹")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modelLi flex df cf wao hao",
                class: { cur: _vm.chooseModel == "browse" },
                on: {
                  click: function($event) {
                    return _vm.tabModel("browse")
                  }
                }
              },
              [_c("b", [_vm._v(_vm._s(_vm.model.browse))]), _vm._v("最近浏览")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.chooseModel == "ask",
                expression: "chooseModel=='ask'"
              }
            ],
            staticClass: "content"
          },
          [
            _vm.$h5Power == "instructor" || _vm.$h5Power == "teacher"
              ? _c("div", { staticClass: "nav df hao" }, [
                  _c(
                    "div",
                    {
                      staticClass: "navLi flex",
                      class: { cur: _vm.chooseNav == "proposeAsk" },
                      on: {
                        click: function($event) {
                          return _vm.tabNav("proposeAsk")
                        }
                      }
                    },
                    [_vm._v("我提出的问题")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "navLi flex",
                      class: { cur: _vm.chooseNav == "proposeAns" },
                      on: {
                        click: function($event) {
                          return _vm.tabNav("proposeAns")
                        }
                      }
                    },
                    [_vm._v("我回答的问题")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "navLi flex",
                      class: { cur: _vm.chooseNav == "followAsk" },
                      on: {
                        click: function($event) {
                          return _vm.tabNav("followAsk")
                        }
                      }
                    },
                    [_vm._v("我关注的问题")]
                  )
                ])
              : _c("div", { staticClass: "nav df hao" }, [
                  _c(
                    "div",
                    {
                      staticClass: "navLi flex",
                      class: { cur: _vm.chooseNav == "proposeAsk" },
                      on: {
                        click: function($event) {
                          return _vm.tabNav("proposeAsk")
                        }
                      }
                    },
                    [_vm._v("我提出的问题")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "navLi flex",
                      class: { cur: _vm.chooseNav == "followAsk" },
                      on: {
                        click: function($event) {
                          return _vm.tabNav("followAsk")
                        }
                      }
                    },
                    [_vm._v("我关注的问题")]
                  )
                ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.chooseNav == "proposeAsk",
                    expression: "chooseNav=='proposeAsk'"
                  }
                ],
                staticClass: "list",
                on: { scroll: _vm.listenScroll_proposeAsk }
              },
              _vm._l(_vm.proposeAskList, function(v, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "li df hao",
                    on: {
                      click: function($event) {
                        return _vm.toDetail(v)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "lt flex" }, [
                      _c("div", { staticClass: "title ov-d" }, [
                        _vm._v(_vm._s(v.title))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tool df" }, [
                        _c("div", { staticClass: "flex" }, [
                          _vm._v(
                            _vm._s(_vm.dateTime(v.createTime)) +
                              " · " +
                              _vm._s(
                                v.answerTotal > 0
                                  ? v.answerTotal + "人回答"
                                  : "暂无回答"
                              ) +
                              " · " +
                              _vm._s(
                                v.attentionTotal > 0
                                  ? v.attentionTotal + "人关注"
                                  : "暂无关注"
                              )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    v.status == 2
                      ? _c("div", { staticClass: "state" }, [
                          _vm._v("审核驳回")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    v.status == 1
                      ? _c("div", { staticClass: "state state2" }, [
                          _vm._v("审核通过")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    v.status == 0
                      ? _c("div", { staticClass: "state state3" }, [
                          _vm._v("正在审核")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    v.status == 255
                      ? _c("div", { staticClass: "state state4" }, [
                          _vm._v("已被删除")
                        ])
                      : _vm._e()
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.chooseNav == "proposeAns",
                    expression: "chooseNav=='proposeAns'"
                  }
                ],
                staticClass: "list",
                on: { scroll: _vm.listenScroll_proposeAns }
              },
              _vm._l(_vm.proposeAnsList, function(v, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "li df hao",
                    on: {
                      click: function($event) {
                        return _vm.toDetail(v)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "lt flex" }, [
                      _c("div", { staticClass: "title ov-d" }, [
                        _vm._v(_vm._s(v.title))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tool df" }, [
                        _c("div", { staticClass: "flex" }, [
                          _vm._v(
                            _vm._s(_vm.dateTime(v.createTime)) +
                              " · " +
                              _vm._s(
                                v.answerTotal > 0
                                  ? v.answerTotal + "人回答"
                                  : "暂无回答"
                              ) +
                              " · " +
                              _vm._s(
                                v.attentionTotal > 0
                                  ? v.attentionTotal + "人关注"
                                  : "暂无关注"
                              )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    v.status == 2
                      ? _c("div", { staticClass: "state" }, [
                          _vm._v("审核驳回")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    v.status == 1
                      ? _c("div", { staticClass: "state state2" }, [
                          _vm._v("审核通过")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    v.status == 0
                      ? _c("div", { staticClass: "state state3" }, [
                          _vm._v("正在审核")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    v.status == 255
                      ? _c("div", { staticClass: "state state4" }, [
                          _vm._v("已被删除")
                        ])
                      : _vm._e()
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.chooseNav == "followAsk",
                    expression: "chooseNav=='followAsk'"
                  }
                ],
                staticClass: "list",
                on: { scroll: _vm.listenScroll_followAsk }
              },
              _vm._l(_vm.followAskList, function(v, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "li df hao",
                    on: {
                      click: function($event) {
                        return _vm.toDetail(v)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "lt flex" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(v.title))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tool df" }, [
                        _c("div", { staticClass: "flex" }, [
                          _vm._v(
                            _vm._s(_vm.dateTime(v.createTime)) +
                              " · " +
                              _vm._s(
                                v.answerTotal > 0
                                  ? v.answerTotal + "人回答"
                                  : "暂无回答"
                              ) +
                              " · " +
                              _vm._s(
                                v.attentionTotal > 0
                                  ? v.attentionTotal + "人关注"
                                  : "暂无关注"
                              )
                          )
                        ])
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.chooseModel == "follow",
                expression: "chooseModel=='follow'"
              }
            ],
            staticClass: "content"
          },
          [
            _vm.$h5Power == "instructor" || _vm.$h5Power == "teacher"
              ? _c("div", { staticClass: "nav df hao" }, [
                  _c(
                    "div",
                    {
                      staticClass: "navLi flex",
                      class: { cur: _vm.chooseNav2 == "meFollow" },
                      on: {
                        click: function($event) {
                          return _vm.tabNav2("meFollow")
                        }
                      }
                    },
                    [_vm._v("我关注的人")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "navLi flex",
                      class: { cur: _vm.chooseNav2 == "followMe" },
                      on: {
                        click: function($event) {
                          return _vm.tabNav2("followMe")
                        }
                      }
                    },
                    [_vm._v("关注我的人")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.chooseNav2 == "meFollow",
                    expression: "chooseNav2=='meFollow'"
                  }
                ],
                staticClass: "list2",
                on: { scroll: _vm.listenScroll_follow }
              },
              _vm._l(_vm.followList, function(v, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "li2 df hao",
                    on: {
                      click: function($event) {
                        return _vm.toFollowUser(v, true)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "lt flex" }, [
                      _c("div", { staticClass: "uname2" }, [
                        _vm._v(_vm._s(v.name))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "duty" }, [
                        _vm._v(_vm._s(v.mapperNumber))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "state state2",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.showCancelFollow(v, 1)
                          }
                        }
                      },
                      [_vm._v("已关注")]
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.chooseNav2 == "followMe",
                    expression: "chooseNav2=='followMe'"
                  }
                ],
                staticClass: "list2",
                on: { scroll: _vm.listenScroll_follow2 }
              },
              _vm._l(_vm.followList2, function(v, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "li2 df hao",
                    on: {
                      click: function($event) {
                        return _vm.toFollowUser(v, v.attentionId)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "lt flex" }, [
                      _c("div", { staticClass: "uname2" }, [
                        _vm._v(_vm._s(v.name))
                      ]),
                      _vm._v(" "),
                      v.post != ""
                        ? _c("div", { staticClass: "duty" }, [
                            _vm._v(_vm._s(v.post))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    v.attentionId
                      ? _c(
                          "div",
                          {
                            staticClass: "state state2",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.showCancelFollow(v, 2)
                              }
                            }
                          },
                          [_vm._v("已关注")]
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "state",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.followUser(v.userId, v)
                              }
                            }
                          },
                          [_vm._v("关注")]
                        )
                  ]
                )
              }),
              0
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.chooseModel == "collect",
                expression: "chooseModel=='collect'"
              }
            ],
            staticClass: "search df hao"
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.collectKeyword,
                  expression: "collectKeyword"
                }
              ],
              staticClass: "flex",
              attrs: { type: "text", puc: "", placeholder: "在收藏夹内搜索" },
              domProps: { value: _vm.collectKeyword },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.collectKeyword = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "btn", on: { click: _vm.searchCollect } })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.chooseModel == "collect",
                expression: "chooseModel=='collect'"
              }
            ],
            staticClass: "content"
          },
          [
            _c(
              "div",
              { staticClass: "list3" },
              _vm._l(_vm.collectList, function(v, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "li3 df hao",
                    on: {
                      click: function($event) {
                        return _vm.toCollectList(v)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "lt flex" }, [
                      _c("div", { staticClass: "title ov-d" }, [
                        _vm._v(_vm._s(v.name))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tool" }, [
                        _vm._v(
                          _vm._s(v.answerTotal + v.questionsTotal) + "个内容"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "edit",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.showCollectAddBase(v)
                        }
                      }
                    })
                  ]
                )
              }),
              0
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.chooseModel == "browse",
                expression: "chooseModel=='browse'"
              }
            ],
            staticClass: "list4",
            on: { scroll: _vm.listenScroll_browse }
          },
          _vm._l(_vm.browseList, function(v, i) {
            return _c(
              "div",
              { key: i, staticClass: "li4" },
              [
                _c("div", { staticClass: "cap" }, [_vm._v(_vm._s(v.day))]),
                _vm._v(" "),
                _vm._l(v.item, function(v2, i2) {
                  return _c(
                    "div",
                    {
                      key: i2,
                      staticClass: "item",
                      on: {
                        click: function($event) {
                          return _vm.toDetail(v2)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(v2.title))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tool" }, [
                        _vm._v(
                          _vm._s(v2.date) +
                            " · " +
                            _vm._s(
                              v2.answerCount > 0
                                ? v2.answerCount + "人回答"
                                : "暂无回答"
                            ) +
                            " · " +
                            _vm._s(
                              v2.followCount > 0
                                ? v2.followCount + "人关注"
                                : "暂无关注"
                            )
                        )
                      ])
                    ]
                  )
                })
              ],
              2
            )
          }),
          0
        )
      ]
    ),
    _vm._v(" "),
    _vm.collectAddBase.has
      ? _c("div", { staticClass: "collectAddBase df wao hao" }, [
          _c("div", { staticClass: "collectAddBase-box" }, [
            _c("div", { staticClass: "collectAddBase-input df hao" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.collectAddBase.val,
                    expression: "collectAddBase.val"
                  }
                ],
                staticClass: "flex",
                attrs: { type: "text", puc: "", placeholder: "输入收藏夹标题" },
                domProps: { value: _vm.collectAddBase.val },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.collectAddBase, "val", $event.target.value)
                    },
                    _vm.checkInput
                  ]
                }
              }),
              _vm._v(" "),
              _c("i", [_vm._v(_vm._s(13 - _vm.collectAddBase.val.length))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "collectAddBase-end df war hao" }, [
              _c(
                "div",
                {
                  staticClass: "collectAddBase-btn",
                  on: { click: _vm.resCollectAddBase }
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collectAddBase-btn",
                  on: { click: _vm.closeCollectAddBase }
                },
                [_vm._v("取消")]
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.cancelFollow.has
      ? _c("div", { staticClass: "cancelFollow df wao hao" }, [
          _c("div", { staticClass: "cancelFollow-box" }, [
            _c("div", { staticClass: "cancelFollow-txt" }, [
              _vm._v("确认不再关注"),
              _c("em", [_vm._v(_vm._s(_vm.cancelFollow.user))]),
              _vm._v("吗？")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cancelFollow-end df war hao" }, [
              _c(
                "div",
                {
                  staticClass: "cancelFollow-btn",
                  on: { click: _vm.closeCancelFollow }
                },
                [_vm._v("放弃")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "cancelFollow-btn",
                  on: { click: _vm.resCancelFollow }
                },
                [_vm._v("取消关注")]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36001390", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36001390","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/me/index/index.vue
// module id = null
// module chunks = 